import React from 'react';

import PropTypes from 'prop-types';

import { Container, Inner } from './styles';

export const NavBar = (props) => {
    return (
        <Container fullwidth={props.fullwidth} isNewMainScreen={props.isNewMainScreen} insideStories={props.insideStories}>
            <Inner
                align={props.align}
                fullwidth={props.fullwidth}
                isSearchBar={props.isSearchBar}
                insideStories={props.insideStories}
                isNewMainScreen={props.isNewMainScreen}
            >
                {props.children}
            </Inner>
        </Container>
    );
};

NavBar.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.arrayOf(PropTypes.element),
        PropTypes.any, //TODO
    ]),
    alignLeft: PropTypes.bool,
    alignRight: PropTypes.bool,
    align: PropTypes.oneOf(['left', 'right', 'space-between', 'center']),
    fullwidth: PropTypes.bool,
    isSearchBar: PropTypes.bool,
    insideStories: PropTypes.bool,
    isNewMainScreen: PropTypes.bool,
};
